import { render, staticRenderFns } from "./BuyerCreateCampaign.vue?vue&type=template&id=2c4132fa&scoped=true"
import script from "./BuyerCreateCampaign.vue?vue&type=script&lang=js"
export * from "./BuyerCreateCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4132fa",
  null
  
)

export default component.exports